<template>
  <div id="services">
    <div class="container-fluid">
      <div class="row main-content">
        <div class="col-md-12">
          <div class="small-title pull-right">
            <hr>
            <h4 v-html="state.title"></h4>
          </div>
          <div class="services-text-main-container" data-aos="fade-down">

            <div class="services-main-container">
              <h1> {{state.subTitle}} </h1>
              <br>
              <p v-html="state.pTextTop"></p>
              <div class="services-icon-text-container">
                <div class="left-icon-text ">
                  <div class="service-icontext-container">
                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_logistica_int.png" width="100px">
                    <h4 class="service-h4">{{state.serviceText1}}</h4>
                  </div>
                  <div class="service-icontext-container">
                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_fronterizo.png" width="100px">
                    <h4 class="service-h4">{{state.serviceText2}}</h4>
                  </div>
                  <div class="service-icontext-container">
                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_operador.png" width="100px">
                    <h4 class="service-h4" v-html="state.serviceText3"></h4>
                  </div>
                  <div class="service-icontext-container">
                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_urgentes.png" width="100px">
                    <h4 class="service-h4">{{state.serviceText4}}</h4>
                  </div>
                </div>
                <div class="right-icon-text ">
                  <div class="service-icontext-container">
                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_transporte.png" width="100px">
                    <h4 class="service-h4">{{state.serviceText5}}</h4>
                  </div>
                  <div class="service-icontext-container">
                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_entrega.png" width="100px">
                    <h4 class="service-h4" v-html="state.serviceText6"></h4>
                  </div>
                  <div class="service-icontext-container">
                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_direccion.png" width="100px">
                    <h4 class="service-h4">{{state.serviceText7}}</h4>
                  </div>
                  <div class="service-icontext-container">
                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_almacen.png" width="100px">
                    <h4 class="service-h4">{{state.serviceText8}}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-10 pull-right contenedor-equipo" style="  z-index:1;" data-aos="fade-in">
            <div class="cornered"></div>
            <div class="equip-div">
              <div :id="index" class="eq-items pull-left hidden" v-for="(inv, key, index) in state.flotilla" :key="key">
                <h1>{{state.titleFlotilla}}
                  <br>
                  <div>
                    <span> {{inv.texto}}</span>
                  </div>
                  <div style="transform:skew(10deg);">
                    <router-link to="/infraestructura" tag="a">
                      <h4 style="color:white; background-color:#d51218; padding:10px;">{{state.btnVerMas}}</h4>
                    </router-link>
                  </div>
                </h1>
                <img :src="invImgUrl(inv.img)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var $ = require('jquery')
export default {
  data() {
    return {
      // 205 cajas secas 53”
      // 15 plataforma 48”
      // 90 tanques
      // 5 tanques food grade
      // 100 Tractocamiones

    }
  },
  methods: {
    invImgUrl(img) {
      return require('../../assets/imgs/' + img + '.png')
    }
  },
  components: {
  },
  computed: {
    state() {
      return this.$store.state.activeList.servicesHome
    }
  },
  mounted() {
    $('.eq-items').first().removeClass('hidden')
    var i = 0
    setInterval(() => {
      $('.eq-items').each((index, val) => {
        if (!$(val).hasClass('hidden') && i !== 1) {
          $(val).addClass('hidden animated fadeIn')
          $(val).next().removeClass('hidden').addClass('animated fadeIn')
          if (index === 5) {
            $('#0').removeClass('hidden')
            $('#0').addClass('animated fadeIn')
          }
          i++
        }
      })
      i = 0
    }, 8000)
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';


.main-content {
  display: block;
  color: $gris;
  height: 100%;
}

.left-icon-text {
  float: left;
}

.right-icon-text {
  float: right;
}

.services-text-main-container {
  padding: 150px;
}

.services-main-container {
  max-width: 1400px;
  margin: auto;
  margin-top: 100px;
}

.services-main-container p {
  font-size: 15pt;
}

.truck-img-contqainer {
  text-align: left;
}

.img-container {
  position: absolute;
  color: white;
  right: 0px;
  height: 100%;
  min-height: 100%;
  background-image: url(../../assets/imgs/home_foto2.png);
}

.services-icon-text-container {
  width: 100%;
  text-align: center;
  padding-left: 15%;
  padding-right: 15%;
  padding-top: 5%;
}

.service-icontext-container {
  margin: auto;
  margin-bottom: 50px;
  text-align: left;
}

.service-h4 {
  font-size: 12pt;
  margin-left: 40px;
  margin-top: 40px;
}

h4 {
  color: $gris;
  display: inline-block;
}



.equip-div img {
  float: right;
  width: 40%;
  padding-top: 30px;
  padding-bottom: 30px;
  display: inline-block;
}

.equip-div h1 {
  color: white;
  padding: 85px;
  font-size: 35pt;
  display: inline-block;
}

.equip-div h1>a {
  color: white;
  padding: 10px 20px;
  background-color: $rojo;
  font-size: 15pt;
  width: 150px;
  height: 100px;
  -webkit-transform: skew(20deg);
  -moz-transform: skew(20deg);
  -o-transform: skew(20deg);
}

hr {
  display: inline-block;
  vertical-align: middle;
  height: 2px;
  border: 0;
  width: 20%;
  border-top: 2px solid $rojo;
  margin: 1em 1em;
  padding: 0;
}

h1 {
  color: $azul;
  font-size: 40pt;
}

.text-container {
  text-align: left;
  margin-top: 5%;
}

.small-title {
  width: 100%;
  text-align: right;
  vertical-align: middle;
  padding: 20px;
}

.cornered {
  width: 100%;
  box-sizing: border-box;
  border-bottom: 31em solid $azul;
  border-left: 7em solid transparent;
}

.equip-div {
  position: absolute;
  top: 0px;
  right: 0;
}

.left-icon-text {
  float: left;
}

.right-icon-text {
  float: right;
}

@media screen and (max-width:1361px) {

  .equip-div img {
    float: right;
    width: 40%;
    padding-top: 30px;
    padding-bottom: 30px;
    display: inline-block;
  }

  .equip-div h1 {
    color: white;
    padding: 85px 0px;
    font-size: 30pt;
    display: inline-block;
  }
  .equip-div h1>a {
    color: white;
    padding: 10px 20px;
    background-color: $rojo;
    font-size: 15pt;
    width: 150px;
    height: 100px;
    -webkit-transform: skew(20deg);
    -moz-transform: skew(20deg);
    -o-transform: skew(20deg);
  }
  .equip-div {
    position: relative;
    top: 0px;
    right: 0;
    background-color: $azul;
  }

  .cornered {
    width: 100%;
    box-sizing: none;
    border-bottom: 0em solid $azul;
    border-left: 0em solid transparent;
  }

  .contenedor-equipo {
    background-color: $azul;
  }
}


@media screen and (max-width:1210px) {
  .service-icontext-container {
    text-align: center;
  }

  .left-icon-text {
    float: none;
    margin: auto;
    text-align: center;
  }

  .img-left-align {
    display: block;
    margin: auto;
  }

  .right-icon-text {
    float: none;
    margin: auto;
  }

  .services-text-main-container {
    padding: 40px;
    text-align: left;
  }

  .services-icon-text-container {
    width: 100%;
    text-align: center;
    padding-left: 0%;
    padding-right: 0%;
    padding-top: 5%;
  }

  .services-icon-text-container img {
    width: 70px;
  }

  .services-icon-text-container h4 {
    font-size: 18pt;
  }

  h1 {
    font-size: 30pt;
  }

  .service-h4 {
    margin-left: 0px;
  }

  .equip-div img {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// ServicesPage.vue?f5633efc